import { IconButton, IconButtonProps } from '@mui/material';
import './ccf-icon-button.module.scss';


/**
 * Component used to display icon button
 * @example <CcfIconButton/>
 */
export function CcfIconButton({children,...other}: IconButtonProps) {
  return (
    <IconButton size="large" {...other}>
      {children}
    </IconButton>
  );
}

export default CcfIconButton;
